import axios from "axios";
import { axiosConfig } from "./AxiosRequest";
import { API_URL } from "./api";

const uploadImages = async (loadingImages, gallery) => {
  const formData = new FormData();
  for (let i = 0; i < loadingImages.length; i++) {
    formData.append("images", loadingImages[i]);
  }

  if (gallery) {
    formData.append("gallery", true);
  }

  const { data } = await axios(axiosConfig("POST", `${API_URL}/images/upload-multiple`, formData, true));

  if (gallery) {
    return data.newImages;
  }

  return data.images;
};

export default uploadImages;
